import React from 'react';
import './CategoryOverview.scss';
import collapseIcon from '../../assets/collapse.svg';

function CategoryOverview({
  currentCategory,
  overviewCopy,
  overview,
  showOverview,
  handleClickCollapse,
  collapseRef
}) {
  return (
    <>
      {showOverview ? (
        <section className="overview" ref={overview}>
          <img
            ref={collapseRef}
            src={collapseIcon}
            alt=""
            className="overview__collapse desktop-only"
            onClick={handleClickCollapse}
          />
          <div className="copy" ref={overviewCopy}>
            <div className="title">
              {currentCategory.title2 === 'FORECAST' ? (
                <p className="overview__title overview__title--forecast">
                  {currentCategory.title1}
                </p>
              ) : (
                <></>
              )}
              {currentCategory.title2 === 'America' ? (
                <p className="overview__title overview__title--intro">
                  The <span className="overview__title--intro--bold">State</span> of
                  <br />
                  <span className="overview__title--intro--big">Housing</span>{' '}
                  <span className="overview__title--intro--small">in</span>
                </p>
              ) : (
                <></>
              )}

              {currentCategory.title2 !== 'America' && currentCategory.title2 !== 'FORECAST' ? (
                <p className="overview__title">{currentCategory.title1}</p>
              ) : (
                <></>
              )}

              <p className="overview__subtitle">{currentCategory.title2}</p>
            </div>
            {currentCategory.title2 === 'America' ? (
              <>
                <p className="overview__copy overview__copy--intro">
                  The State of Housing in America map covers 173 metro areas across America, using
                  data provided by the National Association of REALTORS® (NAR).
                </p>

                <p className="overview__copy">
                  REALTORS®, members of NAR, keep their pulse on the housing market thanks to
                  research and resources from NAR—all to better serve their customers.
                </p>

                <p className="overview__copy">
                  <span className="bold">Click through the tabs</span> at the top of the page to
                  explore the housing market across four key factors.
                </p>
              </>
            ) : (
              <></>
            )}
            {currentCategory.copy2 ? (
              <>
                <p className="overview__copy">{currentCategory.copy}</p>
                <p className="overview__copy">{currentCategory.copy2}</p>
              </>
            ) : (
              <p className="overview__copy">{currentCategory.copy}</p>
            )}

            {currentCategory.average1 ? (
              <>
                <p className="overview__copy overview__averageT">
                  {currentCategory.title1 === 'HOME PRICE' ? 'National Median' : 'National Average'}
                </p>
                <p className="overview__copy overview__averageC">{currentCategory.average1}</p>
              </>
            ) : (
              <></>
            )}
            {currentCategory.average2 ? (
              <p className="overview__copy overview__averageC">{currentCategory.average2}</p>
            ) : (
              <></>
            )}
            {currentCategory.average3 ? (
              <p className="overview__copy overview__averageC">{currentCategory.average3}</p>
            ) : (
              <></>
            )}

            {currentCategory.disclaimer ? (
              <p className="overview__copy overview__disclaimer">{currentCategory.disclaimer}</p>
            ) : (
              <></>
            )}
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
}

export default CategoryOverview;
